import React from "react";
import {Select, Spin} from "antd";
import {NotesList} from "../../models/crm/settings";

const Option = Select.Option;

export class ChooseNotes extends React.Component {
    state = {
        data: [],
        value: [],
        fetching: false
    };

    handleChange = value => {
        this.setState({
            value,
            fetching: false
        });
        this.props.onChange(value.key)
    };
    fetch = (params) => {
        this.setState({fetching: true});
        NotesList(params)
            .then(response => {
                this.setState({data: response.data.results, fetching: true})
            })
    };

    componentDidMount() {
        if (this.props.onRef)
            this.props.onRef(this)
    }

    componentWillUnmount() {
        if (this.props.onRef)
            this.props.onRef(null)
    }

    render() {
        const {fetching, data, value} = this.state;
        return (
            <div className="pos-relative">
                <Select mode="default" labelInValue showSearch value={value} placeholder="Select Here"
                        notFoundContent={fetching ? <Spin size="small"/> : null} filterOption={false}
                        onChange={this.handleChange} style={{width: "100%"}} onFocus={this.fetch} onSearch={this.fetch}>
                    {data.map(item => <Option key={item.id} value={item.description}>{item.title}</Option>)}
                </Select>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/filters/crm/ChooseNotes.jsx